<template>
  <div id="global-uploader">
    <!-- 上传 -->
    <uploader
      ref="uploader"
      :options="options"
      @file-success="onFileSuccess"
      @file-added="onFileAdded"
    >
      <uploader-unsupport></uploader-unsupport>
      <uploader-btn :attrs="attrs" class="upload-btn">上傳視頻</uploader-btn>
      <div class="file-panel" v-show="panelShow">
        <div class="title">
          <el-label class="text">文件上傳清單</el-label>
          <el-button icon="el-icon-close" circle :border="false" size="mini" @click="onClose"></el-button>
        </div>
        <div class="file-list">
          <uploader-list></uploader-list>
        </div>
      </div>
    </uploader>
  </div>
</template>

<script>
import SparkMD5 from "spark-md5";
import { getToken } from "../../config/cache";

export default {
  data() {
    return {
      options: {
        target: `${this.$config.api_url}/admin/videos/upload`,
        testChunks: false,
        // checkChunkUploadedByResponse: function(chunk, message) {
        //   let objMessage = JSON.parse(message);
        //   console.log("message:", objMessage, chunk);
        //   if (objMessage.skipUpload) {
        //     return true;
        //   }
        //   return (objMessage.uploaded || []).indexOf(chunk.offset + 1) >= 0;
        // },
        headers: { Authorization: getToken() }
      },
      attrs: {
        accept: [".mp4"]
      },
      panelShow: false, //選擇文件后，展示上传panel
      collapse: false
    };
  },
  methods: {
    onFileSuccess() {
      this.$emit("sucess");
    },
    onFileAdded(file) {
      this.panelShow = true;
    },
    onClose() {
      this.panelShow = false;
    }
  }
};
</script>

<style scoped lang="less">
#global-uploader {
  .upload-btn{
    background-color: orangered;
    padding:11px 20px;
    border:none;
    color:white;
    font-size: 14px;
    line-height: 1;
    border-radius: 3px;
  }
  .file-panel {
    position: fixed;
    z-index: 20;
    right: 20px;
    bottom: 20px;
    background-color: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 7px 7px 0 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    width: 520px;
    text-align: left;
    padding: 10px;
    .title {
      font-size: 20px;
      display: flex;
      margin-bottom:10px;
      .text{
          flex:1;
      }
    }
    .file-list {
      height: 300px;
      overflow: scroll;
    }
  }
}
</style>